import { RefObject, createContext, useContext } from 'react'

import type { Swiper as SwiperType } from 'swiper'

interface UpsellsCarouselContextValue {
  currentSlide: number
  isBeginning: boolean
  isEnd: boolean
  swiperRef: RefObject<SwiperType | undefined>
}

const UpsellsCarouselContext = createContext<UpsellsCarouselContextValue>({
  currentSlide: 0,
  isBeginning: true,
  isEnd: false,
  swiperRef: { current: undefined },
})

export const useUpsellsCarousel = () => useContext(UpsellsCarouselContext)
export { UpsellsCarouselContext }
